export default __webpack_public_path__ + "static/media/scroll-icon-text.cd87ed6d.png";